// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".no-results-text[data-v-b7083a06]{width:100%!important;white-space:normal}.no-results-text b[data-v-b7083a06]{font-weight:bolder}.no-results-text ul[data-v-b7083a06]{list-style-type:circle!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
